import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import MyAccount from "../components/MyAccount";
import {
  getMfaPreference,
  updateUserDetails,
} from "../../../actions/MyAccount";
import { resetStates } from "../../../actions/Common";
import { MyAccountModel } from "../../../models/MyAccount";
import { getListResult } from "../../../utils";
import { getLoggedInUserByEmail, postUserPageTrack } from "../../../actions/UserAction";
import { UserPageTrack } from "../../../models/User";

const mapStateToProps = ({
  appConfigsState,
  masterMfaPreferenceState,
  updateUserDetailsState,
  loggedInUserState
}: ApplicationState) => ({
  config: appConfigsState.response,
  masterMfaPreferenceState: getListResult(masterMfaPreferenceState.response),
  updateUserDetailsState: updateUserDetailsState.response,
  loggedInUser: loggedInUserState.response,
  loggedInUserFlow: loggedInUserState.flow,
  updateError: updateUserDetailsState.error
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getLoggedInUserByEmail: (userEmail: string) => {
      dispatch(getLoggedInUserByEmail(userEmail, 1));
    },
    getMfaPreference: () => {
      dispatch(getMfaPreference());
    },
    updateUserDetails: (payload: MyAccountModel) => {
      dispatch(updateUserDetails(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
